import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TuiInputFiles, TuiFiles, TuiSkeleton } from '@taiga-ui/kit';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';

import { InputFilesComponent } from './input-files.component';

@NgModule({
  declarations: [InputFilesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ...TuiFiles,
    TuiButton,
    ...TuiHint,
    ComponentsModule,
    TranslateModule,
    TuiSkeleton,
  ],
  exports: [InputFilesComponent],
  providers: [TuiInputFiles],
})
export class InputFilesModule {}
